import { Chart } from "chart.js/auto";

for (const [id, chart] of Object.entries(CHARTS)) {
  CHARTS[id].graph = new Chart(chart.ctx, chart.config);
}

export const getChart = (id) => {
  let chart = CHARTS[id];

  if (!chart) {
    console.error(`Chart ${id} not found!`);
    return null;
  }

  return chart;
};

export const rebuildChart = (id) => {
  let chart = getChart(id);

  if (!chart.graph) {
    console.error(`Chart ${id} graph not initialized!`);
    return;
  }

  chart.graph.destroy();
  chart.graph = new Chart(chart.ctx, chart.config);
};
